import { InferType, number, object, string } from 'yup'
export { provider as baseURL } from 'constants/apiBaseUrls'
import queryString from 'qs'
import { PaginatedResponse } from 'types/api'
import { ProviderMember } from 'types/ProviderMember'
import { toApiNormal, fromApi } from 'api/makeQuery'

const filterSchema = object({
  firstName: string(),
  lastName: string(),
  firstNamePreferred: string(),
  dob: string(),
})

export const Schema = object({
  providerId: string().required(),
  filter: filterSchema,
  page: object({
    skip: number(),
    limit: number(),
  }),
})

export type Request = Omit<InferType<typeof Schema>, 'filter'> & { filter?: Partial<InferType<typeof filterSchema>> }

export type SuccessfulResponse = PaginatedResponse<ProviderMember>

export const url = ({ providerId, page, filter }: Request) =>
  `/v2/providers/${providerId}/members?${queryString.stringify(
    { page, filter: toApiNormal(filter) },
    { indices: false },
  )}`

export const transformResponse = (response: any): SuccessfulResponse => {
  return {
    ...response,
    paginated: response.paginated?.map((member: any) => fromApi(member)) || [],
  }
}
